import { Check } from 'lucide-react';

const COP = (v) => new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 }).format(v);

const FEATURES = [
  'Conciliaciones ilimitadas',
  'Acceso web',
  'Historial permanente',
  'Soporte',
  'Actualizaciones incluidas',
];

export default function Pricing({ onSuscribirse }) {
  return (
    <section id="planes" className="py-20 md:py-28 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-extrabold text-navy-900 tracking-tight">
            Planes simples y accesibles.
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 gap-8 max-w-3xl mx-auto">
          {/* Mensual */}
          <div className="rounded-2xl border border-slate-200 p-8 flex flex-col">
            <p className="text-sm font-semibold text-slate-500 mb-2">Mensual</p>
            <p className="text-4xl font-extrabold text-navy-900">{COP(30000)}<span className="text-base font-medium text-slate-400"> /mes</span></p>
            <p className="mt-3 text-sm text-slate-600">Menos de $1.000 al día para ahorrar horas de trabajo.</p>

            <ul className="mt-7 space-y-3 flex-1">
              {FEATURES.map((f) => (
                <li key={f} className="flex items-center gap-2.5 text-sm text-slate-700">
                  <Check size={16} className="text-brand-green shrink-0" /> {f}
                </li>
              ))}
            </ul>

            <button
              onClick={() => onSuscribirse('mensual')}
              className="mt-8 w-full rounded-lg border-2 border-navy-900 py-3 font-semibold text-navy-900 hover:bg-navy-900 hover:text-white transition-colors"
            >
              Suscribirme mensual
            </button>
          </div>

          {/* Anual */}
          <div className="relative rounded-2xl border-2 border-brand-green p-8 flex flex-col shadow-xl shadow-brand-green/10">
            <span className="absolute -top-3.5 left-1/2 -translate-x-1/2 rounded-full bg-brand-green text-white text-xs font-bold px-4 py-1.5 shadow-md">
              Recomendado
            </span>
            <p className="text-sm font-semibold text-slate-500 mb-2">Anual</p>
            <p className="text-4xl font-extrabold text-navy-900">{COP(240000)}<span className="text-base font-medium text-slate-400"> /año</span></p>
            <p className="mt-3 text-sm text-brand-greenDark font-semibold">Ahorra {COP(120000)} al año.</p>

            <ul className="mt-7 space-y-3 flex-1">
              {FEATURES.map((f) => (
                <li key={f} className="flex items-center gap-2.5 text-sm text-slate-700">
                  <Check size={16} className="text-brand-green shrink-0" /> {f}
                </li>
              ))}
            </ul>

            <button
              onClick={() => onSuscribirse('anual')}
              className="mt-8 w-full rounded-lg bg-brand-green py-3 font-semibold text-white hover:bg-brand-greenDark transition-colors shadow-md"
            >
              Suscribirme anual
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
